export const Save = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5 6C5 5.44772 5.44771 5 6 5H22.0241L27 10.0114V26C27 26.5523 26.5523 27 26 27H6C5.44772 27 5 26.5523 5 26V6Z" stroke="currentColor" stroke-width="2"/>
<path d="M11 18C11 17.4477 11.4477 17 12 17H20C20.5523 17 21 17.4477 21 18V27H11V18Z" stroke="currentColor" stroke-width="2"/>
<path d="M22 11H13C11.8954 11 11 10.1046 11 9V4" stroke="currentColor" stroke-width="2"/>
</svg>`;
